export default {
    setLocationHash(state, payload) {
        if (payload){
            return 
        }
        if (payload.type == "bin-browse") {
            window.location.hash = `file_uid=${payload.file_uid}&file_name=${payload.file_name}&bin_id=${payload.bin_id}`;
        } else if (payload.type == "catalog-browse") {
            window.location.hash = `catalog_id=${payload.catalog_id}&catalog_name=${payload.catalog_name}&catalog_pid=${payload.catalog_pid}`;
        } else if (payload.type == "settings") {
            window.location.hash = `settings_id=${payload.settings_id}&id=${payload.id}`;
        } else if (payload.type == "jobs") {
            if (!(window.location.hash.includes("module"))) {
                if (window.location.hash.includes("file_uid") || window.location.hash.includes("catalog_id")) {
                    window.location.hash += `&module=${payload.module}`;
                } else {
                    window.location.hash = `module=${payload.module}`;
                }
            }
        } else if (payload.type == "reports") {
            if (!(window.location.hash.includes("module"))) {
                if (window.location.hash.includes("file_uid") || window.location.hash.includes("catalog_id")) {
                    window.location.hash += `&module=${payload.module}`;
                } else {
                    window.location.hash = `module=${payload.module}`;
                }
            }
        } else {
            window.location.hash = ""
        }
    },
    setLocationChangeEventListenerCallback(state) {
        window.addEventListener("hashchange", () => {
            if (state.locationCallback != null) {
                state.locationCallback()
            } else if (state.prevCallback != null) {
                state.prevCallback()
            }
        }, false);
    },
    changeLocationCallback(state, payload) {
        if (state.locationCallback != null) {
            state.prevCallback = state.locationCallback
        }
        state.locationCallback = payload.callBack
    },
    resetToOldCallback(state) {
        state.locationCallback = state.prevCallback
    },
    unsetLocationHash() {
        window.location.hash = ""
    },
    unsetLocationChangeEventListenerCallback(state) {
        state.locationCallback = null
        window.location.hash = ""
        window.removeEventListener("hashchange", () => {})
    },
    unsetModule(state, payload) {

        if (window.location.hash.includes("module"))
            if (window.location.hash.includes("file_uid") || window.location.hash.includes("catalog_id")) {
                window.location.hash = window.location.hash.replace(`&module=${payload.module}`, "");
            } else {
                window.location.hash = window.location.hash.replace(`module=${payload.module}`, "");
            }
    },
    setLoadPageInfo(state, payload={}){
        state.loadPageInfo = Object.assign({}, payload)
    },
    
    setPathLocationInfo(state, payload={}){
        state.loadPathInfo = payload;
    },
};